export enum DoodPaymentAtTableAmountType {
  Free = 'free',
  Total = 'total',
  Divide = 'divide',
  Products = 'products',
}
